<template>
  <div class="echarts1" ref="echarts">

  </div>
</template>

<script>

import {FontChart} from "@/utils/utils";
import Axios from "@/utils/Axios";
import Bus from "@/utils/bus.js";
export default {
  name: 'echarts1',
  components: {},
  props: {
    id: {
      type: String,
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      status: '',
      depid:"",
    }
  },
  watch: {},
  mounted() {
    let that=this
    this.getpowdata()
    Bus.$on('changeid',(val)=>{
      this.depid=val.deptId
      that.getpowdata()
    })
  },
  methods: {
    drawLine(alldata) {
      let xdata=[]
      let ydata1=[]
      let ydata2=[]
      for(let i=0;i<alldata.length;i++){
        xdata.push(alldata[i].dateTime)
        ydata1.push(alldata[i].handledCount)
        ydata2.push(alldata[i].unHandledCount)
      }
      var that = this;
      window.addEventListener('resize', this.drawLine)
      let myChart = this.$echarts.init(that.$refs.echarts)
      var option = {
        grid: {
          left: '20',
          right: '30',
          top: '30',
          bottom: '20',
          containLabel: true
        },
        tooltip: {
          show: true,
          trigger: 'axis',
        },
        xAxis: {
          boundaryGap: false,
          data:xdata,
          axisLine: {
            lineStyle: {
              color: '#355ebb',
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#355ebb',
            fontSize: 12
          }
        },
        yAxis: [
          {
            nameTextStyle: {
              color: '#3a62bf',
              fontSize: FontChart(16)
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#355ebb'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              color: '#355ebb',
              fontSize: 12
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#355ebb'
              }
            },
            yAxisIndex: 0
          }],
        series: [
          {
            name: '已处理数量',
            type: 'line',
            smooth: true, //是否平滑
            showAllSymbol: true,
            symbol: 'circle',
            yAxisIndex: 0,
            symbolSize: 0,

            zlevel: 1,
            label: {
              show: false,
              position: 'top',
              textStyle: {
                color: '#f7d349',
              }
            },
            areaStyle: {
              normal: {
                color: this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(199, 237, 250,0.5)",
                    },
                    {
                      offset: 1,
                      color: "rgba(199, 237, 250,0.1)",
                    },
                  ],
                  false
                ),
              },
            },
            itemStyle: {
              normal: {
                color: "#f7b851",
              },
            },
            lineStyle: {
              normal: {
                width: 1,
              },
            },
            data: ydata1
          },
          {
            name: '未处理数量',
            type: 'line',
            smooth: true, //是否平滑
            showAllSymbol: true,
            symbol: 'circle',
            yAxisIndex: 0,
            symbolSize: 0,

            zlevel: 1,
            label: {
              show: false,
              position: 'top',
              textStyle: {
                color: '#f7d349',
              }
            },
            areaStyle: {
              normal: {
                color: this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(216, 244, 247,0.5)",
                    },
                    {
                      offset: 1,
                      color: "rgba(216, 244, 247,0.1)",
                    },
                  ],
                  false
                ),
              },
            },
            itemStyle: {
              normal: {
                color: "#58c8da",
              },
            },
            lineStyle: {
              normal: {
                width: 1,
              },
            },
            data:ydata2
          },
        ]
      }
      myChart.clear()
      myChart.resize()
      myChart.setOption(option)
    },
    getpowdata(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/portal/riskTrend"

      param.data={
        deptId:this.depid,
      }
      Axios.ajax(param).then((res)=>{
        if(res.resultCode=='0'){

          this.drawLine(res.data)
        }else{

        }

      })
    },
  }
}
</script>

<style lang="scss" scoped>
.echarts1 {
  position: relative;
  width: 100%;
  height: calc(100% - 0px);
}
</style>
